module.exports = __webpack_public_path__ + "static/media/iconBack.158bfa7e.svg";